import { render } from "./LoadingState.vue?vue&type=template&id=40f2d98f"
import script from "./LoadingState.vue?vue&type=script&lang=js"
export * from "./LoadingState.vue?vue&type=script&lang=js"
script.render = render

export default script